///<reference path="../../node_modules/@angular/core/src/event_emitter.d.ts"/>
import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Http, RequestOptions, Headers } from '@angular/http';
import { globalSettings } from './shared/config';
import { AuthService } from './auth/auth.service';
import 'rxjs/add/operator/toPromise';
import { COMAPNIES, PENDING_REGISTRATION } from './consts/requests';

@Injectable()
export class DataService {
    constructor(private http: Http,
                private authService: AuthService) {
    }

    public newCompany(body) {
        body.url = 'lkj;lkj';
        return this.postResponse(COMAPNIES, body)
    }

    public newRegistration(body) {
        return this.postResponse(PENDING_REGISTRATION, body)
    }

    public jsonHeaders(token): Headers {

        const headers: Headers = new Headers({'Accept': 'application/json'});

        if (token) {
            headers.append('Authorization', token);
        }

        return headers;
    }

    public getCompanies(limit, skip, order, search) {
        let url = `${COMAPNIES}?limit=${limit}&skip=${skip}&search=${search}`;
        if (order === 2) {
            url += '&order=desc'
        } else if (order === 3) {
            url += '&order=asc'
        }
        return this.getResponse(url);
    }

    public getRegistrations(limit, skip, order, search) {
        let url = `${PENDING_REGISTRATION}?limit=${limit}&skip=${skip}&search=${search}`;
        if (order === 2) {
            url += '&order=desc'
        } else if (order === 3) {
            url += '&order=asc'
        }
        return this.getResponse(url);
    }

    public getResponse(url) {
        const requestOptions: RequestOptions = new RequestOptions({
            headers: this.jsonHeaders(JSON.parse(localStorage.getItem('token_login'))),
            method: 'get',
        });
        return this.http.request(globalSettings.url + url, requestOptions)
    }

    public deleteResponse(url) {
        const requestOptions: RequestOptions = new RequestOptions({
            headers: this.jsonHeaders(JSON.parse(localStorage.getItem('token_login'))),
            method: 'delete',
        });
        return this.http.request(globalSettings.url + url, requestOptions)
    }

    public postResponse(url, data) {
        const headers = this.jsonHeaders(JSON.parse(localStorage.getItem('token_login')));

        return this.http.post(globalSettings.url + url, data, {
            headers: headers
        });
    }
}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/data.service.ts